'use strict';

if (!Symbol.species) {
    Symbol.species = Symbol.for('@@species');
}



// WEBPACK FOOTER //
// ./node_modules/ml-pca/node_modules/ml-matrix/src/symbol-species.js